<template>
  <!--商品推荐 merchandiseRecommend-->
  <div>
    <x-tabula
        ref="table"
        rowKey="recommendId"
        :dataSource="dataSource"
        :searchList="searchList"
        :columns="columns"
        :tableOptList="tableOptList"
        :rowOptList="rowOptList"
        :searchParams.sync="searchParams"
        :listApi="listApi"
        :deleteParam="deleteParam"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-switch v-hasPermi="['community:localGoodsRecommend:editStatus']"  @change="changeStatus(row)" :checked="Number(row.status) ? true : false"/>
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{ statusObj[row.status] }}</span>
        </div>
      </template>
      <template slot="opt_type" slot-scope="{row}">
        {{ getTypeDesc(row.type) }}
      </template>
      <template slot="opt_img" slot-scope="{row}">
        <img style="height: 44px;width:auto" :src="row.img" alt="">
      </template>
    </x-tabula>

    <!--选择商品弹窗-->
    <a-modal
        :title="modalTitle"
        :visible="visible"
        @cancel="visible=false"
        @ok="CMConfirm"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="1000px"
    >
      <product-list ref="productList"></product-list>
    </a-modal>

    <!-- 设置排序 -->
    <a-modal
        title="设置排序"
        :visible="sortVisible"
        @cancel="sortVisible=false"
        @ok="sortFun"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="400px"
    >
      <template >
          <a-form :form="form" v-bind="itemLayout || $store.state.base_itemLayout">
            <a-form-item
              label="排序"
              v-bind="$store.state.modal_ItemLayout"
              >
                <a-input type = 'number' v-model="sort"
                  v-decorator="[
                    'sort',
                    { rules: [{ required: true, message: '请输入排序' },
                    { max: 5, message: '最多5位数' },
                    { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
                    ] },
                  ]"
             />
            </a-form-item>
          </a-form>
      </template>
    </a-modal>
  </div>
</template>

<script>
import productList from './productList.vue';
import { fetchSelect } from '../../../utils/mixins';
export default {
  name: 'merchandiseRecommend',
  mixins: [fetchSelect],
  components: {
    productList
  },
  data () {
    return {
      form: this.$form.createForm(this),
      sort: 0,
      rowId: undefined,
      sortVisible: false,
      leaderVisible: false,
      modalTitle: '选择商品',
      visible: false,
      btnLoading: {loading: false},
      formList: [
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          disabled: false,
          props: ['mobilePhone', {
            rules: [
              {required: true, message: '请输入排序'}
            ]
          }]
        }
      ],
      searchList: [
        {props: ['title'], placeholder: '商品名称', inputType: 'input'},
        {props: ['status'], placeholder: '状态', options: [], inputType: 'select'},
        {
          label: '',
          props: ['areas'],
          placeholder: '所在地区',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(2, 'searchList', '1,2', e);
          }
        },
        {
          label: '',
          props: ['scopeType'],
          placeholder: '推荐位',
          options: [
          ],
          inputType: 'select'
        }
      ],
      tableOptList: [
        {text: '选择商品', icon: 'plus', handle: this.openModal, permi: ['community:localGoods:choose']},
        {text: '删除', icon: 'close', disabled: true, permi: ['community:localGoodsRecommend:remove'] }
      ],
      rowOptList: [
        {text: '设置排序', handle: (row) => this.showSort(row), permi: ['community:localGoodsRecommend:editSort']},
        {text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), key: 'delete', permi: ['community:localGoodsRecommend:remove']}
      ],
      columns: [
        {title: '封面图', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'img' }},
        {title: '标题', dataIndex: 'title', align: '', width: ''},
        {title: '类型', dataIndex: 'typeDesc', align: '', width: ''},
        {title: '店铺', dataIndex: 'shopName', align: '', width: ''},
        {title: '推荐位', dataIndex: 'scopeTypeDesc', align: '', width: ''},
        {title: '排序', dataIndex: 'sort', align: '', width: ''},
        {title: '推荐状态', dataIndex: '', align: '', width: '200px', scopedSlots: {customRender: 't'}},
        {title: '状态', dataIndex: 'status', align: '', width: '200px', scopedSlots: {customRender: 'status'}},
        {title: '操作', dataIndex: 'action', align: '', width: '200px', scopedSlots: {customRender: 'action'}}
      ],
      statusObj: ['未推荐', '推荐中'],
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        title: undefined,
        status: undefined,
        areas: undefined,
        scopeType: undefined
      },
      listApi: {
        url: '/local/goodsRecommend/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/goodsRecommend/',
        param: {},
        title: '该商品推荐',
        key: 'title'
      },
      selectedArera: undefined
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 选择商品弹窗 */
    CMConfirm () {
      let id = this.$refs.productList.getSelectId();
      let scopeType = this.$refs.productList.scopeType;
      if (id.length > 0) {
        let obj = {
          goodIds: id,
          scopeType
        };
        this.submitRestart(obj);
      } else {
        this.$message.error('请选择商品');
      }
    },
    /** 提交搜索数据同步 */
    submitRestart (values) {
      this.$post({
        url: '/local/goodsRecommend/add',
        params: {...values},
        btnLoading: this.btnLoading
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功');
          this.$refs.table.getTableList({current: 1});
          this.visible = false;
        } else {

        }
      });
    },
    showSort (row) {
      this.sort = row.sort;
      this.rowId = row.recommendId;
      this.sortVisible = true;
      setTimeout(() => {
        this.form.setFieldsValue({sort: row.sort});
      }, 100);
    },
    sortFun () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.$put({
          url: `/local/goodsRecommend/editSort/${this.rowId}`,
          params: {
            sort: this.sort
          }
        }).then(({data}) => {
          this.$message.success('设置成功！');
          this.sortVisible = false;
          this.$refs.table.getTableList();
        });
      });
    },
    /** 获取类型下拉 */
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_local_goodRecommend_scope_type',
        params: {}
      }).then(({data}) => {
        this.searchList[3].options = data;
      });
      this.regionSelect(2);
      this.searchList[1].options = [
        {label: '未推荐', value: '0'},
        {label: '推荐中', value: '1'}
      ];
    },

    dataTypeChange (val) {
      this.formList.forEach((el) => {
        el.slot === val ? el.show = true : el.show = false;
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/local/goodsRecommend/changeStatus/${row.recommendId}`,
        params: {
          status: status
        }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    /** 选择商品 */
    openModal () {
      this.modalTitle = '选择商品';
      this.visible = true;
    },

    getTypeDesc (type) {
      for (let i = 0; i < this.searchList[1].options.length; i++) {
        if (this.searchList[1].options[i].value === type + '') {
          return this.searchList[1].options[i].label;
        }
      }
      return '';
    },
    resHandle (res) {
    },
    searchHandle (selectData) {
    },
    reqHandle (param) {
      return param;
    }
  }
};
</script>
